import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/profile/:id';

const AccountsRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('./Accounts')),
    name: 'Accounts',
};

export default AccountsRoute;
